import { createGlobalStyle, css } from 'styled-components'
import theme from '../../theme'
import { hoverState } from './mediaQueries'
import '@fontsource/open-sans'
import '@fontsource/open-sans/700.css'

const GlobalStyle = createGlobalStyle`
    :root {
        font-size: 62.5%;
    }
    body {
        background-color: ${theme.color.backgroundColor};
    }
    body, select, input, textarea, button, p, a{
        font-family: 'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';
        font-size: ${theme.typography.defaultFontSize};
        color: ${theme.color.textColor};
        -webkit-font-smoothing: antialiased;

    }
    select, input, textarea, p, a, button{
        line-height: ${theme.typography.lineHeight};

    }
    svg {
        width: ${(props) => props.theme.typography.defaultIconSize};
        height: ${(props) => props.theme.typography.defaultIconSize};
    }
    *,*::before,*::after {
        box-sizing: border-box;
    }
    a{
        text-decoration: underline;
        ${hoverState(css`
          text-decoration: none;
        `)}
    }
    /* Holds at full colour before fading, so the mark is catchable on a row that was already
       on screen and needed no scrolling. */
    @keyframes validation-target-highlight-fade {
        0%, 30% { background-color: var(--validation-target-highlight-color, ${
          theme.color.chipWarningBackground
        }); }
        100% { background-color: transparent; }
    }
    .validation-target-highlight {
        animation: validation-target-highlight-fade ${
          theme.timing.validationTargetHighlightMs
        }ms ease-out;

        /* Hold the colour; the timer still removes the class. */
        @media (prefers-reduced-motion: reduce) {
            animation: none;
            background-color: var(--validation-target-highlight-color, ${
              theme.color.chipWarningBackground
            });
        }
    }
`

export default GlobalStyle
